import {useState} from 'react'

import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useSearchParams} from '@github-ui/use-navigate'

import {mcpRegistryRoute} from '../mcp-registry-route'

import {Content} from './_components/Content/Content'
import {Header} from './_components/Header/Header'

export function McpRegistry() {
  const payload = useRouteQuery(mcpRegistryRoute, 'mainQuery')

  const [searchParams, setSearchParams] = useSearchParams()
  const [searchQuery, setSearchQuery] = useState(searchParams.get('q') || '')

  const handleSearchChange = (query: string) => {
    setSearchQuery(query)

    // Update URL search params to trigger server-side search
    const newSearchParams = new URLSearchParams(searchParams)
    if (query.trim()) {
      newSearchParams.set('q', query.trim())
    } else {
      newSearchParams.delete('q')
    }

    // Reset cursor and limit when search changes
    newSearchParams.delete('cursor')
    newSearchParams.delete('limit')

    setSearchParams(newSearchParams, {preventAutofocus: true})
  }

  return (
    <>
      <Header searchQuery={searchQuery} onSearchChange={handleSearchChange} />
      <Content searchQuery={searchQuery} data={payload.data.serversData} />
    </>
  )
}

try{ McpRegistry.displayName ||= 'McpRegistry' } catch {}